// bootstrap/packages.js
import '@/packages/font-awesome'
import '@/packages/vee-validate'
import '@/packages/moment'
import '@/packages/draggable'
import '@/packages/vue-meta'
import '@/packages/floating-vue'
import '@/packages/vue-sanitize'
import '@/packages/vue-cookie'
import '@/packages/logrocket'
import '@/packages/vue-datetime'
import store from '@/packages/vuex'
import { createVueRouter } from '@/packages/vue-router'
import { createI18n } from '@/packages/vue-i18n'
import apolloProvider from '@/packages/vue-apollo'
import Permissions from '@/plugins/permissions'

export async function setupPackages () {
	const i18n = await createI18n()
	const router = createVueRouter()

	return {
		i18n,
		router,
		store,
		apolloProvider,
		Permissions
	}
}
